import { Stack, styled } from '@mui/material';

import AcadlyProgressbar from '../../../../../../components/Progressbar';
import { generateClasses } from '../../../../../../utils/helper';

export const attendanceProgressbarClasses = generateClasses('attendanceProgressbar', ['label']);

export const Root = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2.5),
  position: 'relative',

  [`& .${attendanceProgressbarClasses.label}`]: {
    position: 'absolute',
    inset: 0,
    zIndex: -1,
  },
}));

export const Progressbar = styled(AcadlyProgressbar)(({ theme }) => ({
  '&::before': {
    content: 'none',
  },
}));
